<template>
  <div class="relative">
    <v-avatar
      class="member-avatar"
      :class="[
        { 'member-avatar--small': size < 30 },
        {'member-avatar--with-action': isAvatarWithAction}
      ]"
      :color="user | fullName | avatarColor"
      :title="user | fullName"
      :size="size"
    >
      {{ user | memberInitials }}
    </v-avatar>
    <v-icon
      v-if="isAvatarWithAction"
      small
      color="white"
      class="avatar-actions"
    >
      mdi-cog-outline
    </v-icon>
  </div>
</template>

<script>
export default {
  props: {
    user: {
      type: Object,
      required: true,
    },
    size: {
      type: [Number, String],
      default: 34,
    },
    actions: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isAvatarWithAction() {
      return this.actions && this.user.actionsAvailable;
    },
  },
};
</script>

<style lang="scss">
.member-avatar {
  border: 1px solid #fff !important;
  font-size: 14px;
  color: white;
  font-weight: bold;

  &--small {
    font-size: 10px;
  }
  &--with-action {
    border: 3px solid $golden !important;
  }
}

.avatar-actions {
  position: absolute !important;
  right:0;
  bottom: 0;
  background-color: $golden;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  transform: translate(25%, 25%) scale(0.9)
}
</style>
